import React from "react";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {ZzIconButtonRoute} from "core/components/buttons/icons";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import mdEntityService from "core/metamodel/mdEntityService";
import Grid from 'core/grid/domain/grid';
import {TabTemplate} from "core/common/config/mui-theme";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, IDomainObject, lovValue} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridComp from "core/grid/component/gridComp";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import eventService from "core/event/eventService";
import ActivityConfigForm from "core/event/component/activityConfigForm";
import {tabStyle} from 'core/common/config/variables';
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, SECURABLE_TYPE, PageProps} from "core/metamodel/metaConstant";
import {ActivityConfig} from "core/event/eventDomain";
import {MovingBlocks, GridComposite, Movable} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {observer} from "mobx-react";
import {action} from "mobx";
import {GridCompositeComp} from "core/grid/component/gridComp";
import {getSelectGridLocation, setSelectGridLocation} from "core/grid/gridSelectionSupport";
import {
  getSelectTenant, getSelectTenantGroup, setSelectTenant,
  setSelectTenantGroup
} from "core/tenant/tenantSelectionSupport";
import {loc} from "../common/config/locales";



const activityTemplateGridLocation = 'activityTemplateList';
const tenantGridComposite = 'tenantGridComposite';
const tenantGridLocation = 'tenantList';
const tenantGroupListLocation = 'tenantGroupList';
const gridLocationListLocation = 'gridLocationSelectionList';

@observer
export default class ActivityConfigDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Activity Config';
  static icon = 'send';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("ActivityConfigDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['ActivityConfig']);

    let activityPromise: Promise<ActivityConfig>;

    if (routerParams.id === 'new') {
      activityPromise = Promise.resolve(new ActivityConfig({$new: true}));
    } else {
      activityPromise = eventService.readActivityConfig(routerParams.id);
    }

    let gridPromise = gridService.fetchGrids(activityTemplateGridLocation, tenantGridLocation, tenantGroupListLocation, gridLocationListLocation);

    return Promise.all([metadataPromise, activityPromise, gridPromise])
      .then(([entityMap, activityConfigObject, gridLocationMap]: [any, ActivityConfig, any]) => {

        activityConfigObject.$movingBlocks = new MovingBlocks(tenantGridComposite, true, query.tab,
          new Grid(gridLocationMap.get(activityTemplateGridLocation), activityConfigObject.activityConfigId),
          new GridComposite(tenantGridComposite, 'Tenant selection', new Grid(gridLocationMap.get(tenantGridLocation)),
                          new Grid(gridLocationMap.get(tenantGroupListLocation))),
          new Grid(gridLocationMap.get(gridLocationListLocation), lovValue(activityConfigObject.rootEntity))
           );

        eventService.activityConfigObject = activityConfigObject.initAfterRead(false);
      });
  }



  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      eventService.activityConfigObject.$movingBlocks.searchExposedGrids(eventService.activityConfigObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    eventService.activityConfigObject.$movingBlocks.searchExposedGrids(eventService.activityConfigObject);
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    eventService.activityConfigObject = null;
  }



  customValidate = (activityConfigObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return eventService.activityConfigObject;
  }



  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(eventService.activityConfigObject, this.customValidate);
    if (!result) {
      return;
    }


    eventService.saveActivityConfig(eventService.activityConfigObject)
      .then( action("activitySave-callback", (activityConfigJson: IDomainObject) => {
        let wasNew = eventService.activityConfigObject.cleanAfterSave(activityConfigJson);
        if (wasNew) {
          this.context.router.replaceWith('activityConfigDetail', {id: eventService.activityConfigObject.activityConfigId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        eventService.activityConfigObject.$errors = error.getMessages();
      });

  };



  onAdd = (evt) => {
    console.log('onAdd');
    this.context.router.transitionTo("activityConfigDetail", {id: 'new'});
  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    eventService.deleteActivityConfig(eventService.activityConfigObject.activityConfigId)
      .then(response => {
        this.context.router.transitionTo('activityConfigList');
      }, error => {
        eventService.activityConfigObject.$errors = error.getMessages();
      });
  };


  onRootEntitySuccess = () => {
    console.log("onRootEntitySuccess");
    let grid: Grid = eventService.activityConfigObject.$movingBlocks.getBlock(gridLocationListLocation) as Grid;
    grid.masterId = lovValue(eventService.activityConfigObject.rootEntity);
    return grid.search(eventService.activityConfigObject);
  };


  render() {

    let {
      query
    } = this.props;


    const propsForCreateForm = {
      dataObject: eventService.activityConfigObject,
      rootObject: eventService.activityConfigObject,
      entity: mdEntityService.getEntity('ActivityConfig'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c activityConfigDetail render query %O', 'background-color: yellow', this.props.query);


    const mainForm = (
      <form style={{marginTop: 10}}>
        <div className="row">
          <div className="col-xs-12">
            <ActivityConfigForm {...propsForCreateForm} onRootEntitySuccess={this.onRootEntitySuccess} />
          </div>
        </div>
      </form>
    );


    let movingBlocks = eventService.activityConfigObject.$movingBlocks;

    const gridCompArray = [
      <GridComp grid={movingBlocks.getBlock(activityTemplateGridLocation) as Grid}
                uiLocation={movingBlocks.getUiLocation(activityTemplateGridLocation)}
                 entities={mdEntityService.entityMap}>
        <ZzIconButtonRoute big routeName="activityTemplateDetail" params={{id: 'new'}} query={eventService.activityConfigObject.createLov()}
                           securable="activityTemplateDetail" permission={PERMISSION.New}>
          <Add/>
        </ZzIconButtonRoute>
      </GridComp>,
      <GridCompositeComp grid={movingBlocks.getBlock(tenantGridComposite) as GridComposite} uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} >
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>Select Tenants</h4>
          <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[0]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenant: getSelectTenant.bind(this, eventService.activityConfigObject), setSelectTenant: setSelectTenant.bind(this, eventService.activityConfigObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>or select Tenant Groups</h4>
          <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[1]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenantGroup: getSelectTenantGroup.bind(this, eventService.activityConfigObject), setSelectTenantGroup: setSelectTenantGroup.bind(this, eventService.activityConfigObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
      </GridCompositeComp>,
      <GridComp grid={movingBlocks.getBlock(gridLocationListLocation) as Grid} multiSelect={false} uiLocation={movingBlocks.getUiLocation(gridLocationListLocation)}
                functionMap={{getSelectGridLocation: getSelectGridLocation.bind(this, eventService.activityConfigObject), setSelectGridLocation: setSelectGridLocation.bind(this, eventService.activityConfigObject)}}
                entities={mdEntityService.entityMap} hideGridConfig hideRefresh />
    ];

    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}  value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));


    const tabs = (tabArray.length) ? (
      <Tabs value={movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange}>
        {tabArray}
      </Tabs>
    ) : '';



    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}} >
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(eventService.activityConfigObject, query.gridLocation)}
            <ErrorComp messages={eventService.activityConfigObject.$errors} />
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          {this._createToolMenu(eventService.activityConfigObject, query.gridLocation)}
          <ErrorComp messages={eventService.activityConfigObject.$errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }


  _createToolMenu(activityConfigObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} activeTab={activityConfigObject.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave} disabled={!activityConfigObject.$dirty} label="Save" permission={activityConfigObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={activityConfigObject.$new} label="New" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="ActivityConfig" pageAncestor={this} onClick={this.onDelete} disabled={activityConfigObject.$new} label="Delete" permission={PERMISSION.Delete}/>

      </Toolmenu>
    );
  }




}




// WEBPACK FOOTER //
// ./src/core/event/activityConfigDetail.tsx